import { FC } from 'react';
import { IGeneralData, IorderProductsData, IShipmentData } from '../../../../../../../types/orders';
import ShipmentCard from '../ShipmentCard/ShipmentCard';
import { groupBySku } from '../../../../../../../utils/groupBySku';

import './ShipmentDetailsCard.scss';

interface IShipmentDetailsCard {
  isEnabled: boolean;
  updateWithoutLoaders: () => Promise<void>;
  updateWithLoaders: () => Promise<void>;
  generalData: IGeneralData;
  listOfGroupedShipments?: IShipmentData[];
  orderId?: string;
  listProducts?: IorderProductsData;
}

const ShipmentDetailsCard: FC<IShipmentDetailsCard> = ({
  isEnabled,
  updateWithoutLoaders,
  updateWithLoaders,
  generalData,
  listOfGroupedShipments,
  orderId,
  listProducts
}: IShipmentDetailsCard) => {
  const references = Object.values(listProducts || {})?.[0]?.references;

  return (
    <div id="shipmentDetailsCard">
      <div className="containerSections">
        <div className="w-full">
          {listOfGroupedShipments &&
            listOfGroupedShipments.length &&
            listOfGroupedShipments.map((shipment, index) => {
              // para generar un cartel de estado de envío debemos agrupar los productos por SKU
              const productsBySku = groupBySku(shipment?.products || []);
              return productsBySku.map(productsInShippingGroup => {
                // datos completos de cada uno de los grupos, por eso se toma el índice del primer map
                const completeDataForEachGroupOfShipments = listOfGroupedShipments[index];
                return (
                  <ShipmentCard
                    key={`completeDataForEachGroupOfShipments-${completeDataForEachGroupOfShipments.shipmentId}}`}
                    listOfGroupedShipments={listOfGroupedShipments}
                    productsInShippingGroup={productsInShippingGroup}
                    completeDataForEachGroupOfShipments={completeDataForEachGroupOfShipments}
                    isEnabled={isEnabled}
                    index={index}
                    orderId={Number(orderId)}
                    generalData={generalData}
                    updateWithoutLoaders={() => updateWithoutLoaders()}
                    updateWithLoaders={updateWithLoaders}
                    references={references}
                  />
                );
              });
            })}
        </div>
      </div>
    </div>
  );
};

export default ShipmentDetailsCard;
